import React, { Component } from 'react'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

import {
  checkIfIsLoopedLogin,
  refreshToken,
  isOutsideIframe,
  isAuth,
} from 'utils/auth'

import AuthorizedRoute from './AuthorizedRouter'
import DisplayCategories from 'pages/DisplayCategories'
import CustomTenders from 'pages/CustomTenders'
import Items from 'pages/Items'
import Merchants from 'pages/Merchants'
import ModifierGroups from 'pages/ModifierGroups'
import OAuthCallback from 'containers/OAuthCallback'
import PriceLevels from 'pages/PriceLevels'
import ReportingCategories from 'pages/ReportingCategories'
import RevenueCentersPage from 'pages/RevenueCenters'
import RevenueCentersDetailsPage from 'pages/RevenueCentersDetails'
import SalesEvents from 'pages/SalesEvents'
import VenueSettings from 'pages/VenueSettings'
import PosAccountsPage from 'pages/PosAccounts'

export default class Routes extends Component {
  tokenRefreshIntervalId = null

  componentDidMount() {
    if (isOutsideIframe()) {
      if (isAuth()) {
        localStorage.removeItem('redirectToLoginAttemptedCheck')
        this.setTokenRefreshInterval(refreshToken)
      } else {
        checkIfIsLoopedLogin()
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.tokenRefreshIntervalId)
  }

  setTokenRefreshInterval = (callback) => {
    callback()
    this.tokenRefreshIntervalId = setInterval(() => callback(), 60000)
  }

  render() {
    return (
      <Router>
        <Switch>
          <Route
            component={OAuthCallback}
            exact
            path="/oauth/callback"
          />
          <Route
            component={() => checkIfIsLoopedLogin()}
            exact
            path="/login"
          />
          <AuthorizedRoute component={Items} exact path="/items" />
          <AuthorizedRoute
            component={PriceLevels}
            exact
            path="/price-levels"
          />
          <AuthorizedRoute
            component={DisplayCategories}
            exact
            path="/categories"
          />
          <AuthorizedRoute
            component={ReportingCategories}
            exact
            path="/reporting-categories"
          />
          <AuthorizedRoute
            component={ModifierGroups}
            exact
            path="/modifier-groups"
          />
          <AuthorizedRoute
            component={SalesEvents}
            exact
            path="/sales-events"
          />
          <AuthorizedRoute
            component={RevenueCentersPage}
            exact
            path="/revenue-centers"
          />
          <AuthorizedRoute
            component={RevenueCentersDetailsPage}
            exact
            path="/revenue-centers/:revenueCenterId"
          />
          <AuthorizedRoute
            exact
            component={CustomTenders}
            path="/custom-tenders"
          />
          <AuthorizedRoute
            exact
            component={VenueSettings}
            path="/venue-settings"
          />
          <AuthorizedRoute
            exact
            component={Merchants}
            path="/merchants"
          />
          <AuthorizedRoute
            exact
            component={PosAccountsPage}
            path="/pos-accounts"
          />
          <Redirect from="/" to="/items" />
        </Switch>
      </Router>
    )
  }
}
